import PropTypes from "prop-types";
import { RiArrowDownSLine } from "react-icons/ri";
import { useEffect, useState } from "react";
import defaultImage from "../../../utils/DefaultImage";
import { IoIosArrowBack } from "react-icons/io";

const WineView = (props) => {
  const {
    currentWineData,
    handleCancel,
  } = props;

  const [openDropdownQuantity, setOpenDropdownQuantity] = useState(null);
  const [b2bPrice, setB2BPrice] = useState("");
  const [servedPrice, setServedPrice] = useState("");
  const [quantities, setQuantities] = useState("");

  useEffect(() => {
    if (currentWineData?.meta?.length > 0) {
      setB2BPrice(currentWineData?.meta?.[0]?.b2b_price || "");
      setServedPrice(currentWineData?.meta?.[0]?.served_price || "");
      setQuantities(currentWineData?.meta?.[0]?.quantity || "");
    }
  }, [currentWineData]);

  const toggleDropdownBoxQuantity = (orderId) => {
    setOpenDropdownQuantity(openDropdownQuantity === orderId ? null : orderId);
  };

  const handleQuantitySelect = (wineId, quantity) => {
    const selectedMeta = currentWineData?.meta?.find(
      (meta) => meta.wine_id === wineId && meta.quantity === quantity
    );

    if (selectedMeta) {
      setB2BPrice(selectedMeta.b2b_price || "");
      setServedPrice(selectedMeta.served_price || "");
      setQuantities(quantity);
    } else {
      setB2BPrice("");
      setServedPrice("");
      setQuantities("");
    }
    setOpenDropdownQuantity(null);
  };

  return (
    <section className="border-t border-[#D9D9D9] mt-5 pt-5 h-[90vh] overflow-y-scroll">
      <h3 className="text-4xl font-bold mb-2 poppins-medium">Lista Vini</h3>
      <div className="w-auto h-auto bg-[#FCFCFC] border-[1.5px] border-[#8B24332B] p-7 rounded-xl shadow-md font-sans">
        <h3 className="text-xl font-bold mb-2 poppins-regular">Informazioni</h3>
        <div className="border-b-[1px] border-[#e4d5d7] mb-6"></div>
        <div className="space-y-4">
          <div className="flex md:flex-row flex-col gap-6">
            <div className="flex flex-col md:w-[50%] w-fll space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Nome prodotto:
              </label>
              <input
                type="text"
                placeholder="Compania Aglianico Le Fole 2010"
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                value={currentWineData?.name || ""}
                disabled
              />
            </div>
            <div className="flex flex-col md:w-[50%] w-full space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Descrizione breve:
              </label>
              <input
                type="text"
                placeholder="I vini di questa carta sono stati scelti nel.."
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-[#7777775c] border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                value={currentWineData?.short_description?.replace(/<[^>]+>/g, '') || ""}
                disabled
              />
            </div>
          </div>
          <div className="flex flex-col w-fll space-y-3">
            <label className="text-sm font-semibold poppins-medium text-[#404040]">
              Descrizione Collaborazione:
            </label>
            <textarea
              placeholder="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Itaque quaerat et hic suscipit voluptates blanditiis quos provident eius! A magnam quaerat cupiditate veritatis similique nam repudiandae mollitia atque. Labore, aliquam?"
              className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] border-[#7777775c] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
              rows={4}
              value={currentWineData?.long_description?.replace(/<[^>]+>/g, '') || ""}
              disabled
            />
          </div>
        </div>

        <h3 className="text-xl font-bold mt-8 mb-4 poppins-regular">Prezzi</h3>
        <div className="border-b-[1px] border-[#e4d5d7] mb-6"></div>
        <div className="space-y-5">
          <div className="flex md:flex-row flex-col gap-6">
            <div className="flex md:w-[50%] flex-col gap-6">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Prezzo Bottiglia (€):
              </label>
              <input
                type="text"
                placeholder="9,59"
                className="px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#E5E5E5] poppins-regular"
                // value={currentWineData?.served_price || "0.00"}
                // value={selectedServedPrice[currentWineData?.id] || "0.00"}
                value={servedPrice || "0.00"}
                disabled
              />
            </div>
            <div className="flex flex-col md:w-[50%] w-full gap-6">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Prezzo Horeca (€):
              </label>
              <input
                type="text"
                placeholder="12,25"
                className="px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#E5E5E5] poppins-regular"
                // value={currentWineData?.b2b_price || "0.00"}
                value={b2bPrice || "0.00"}
                disabled
              />
            </div>
          </div>
        </div>

        <h3 className="text-xl font-bold mt-8 mb-4 poppins-regular">Immagini</h3>
        <div className="border-b-[1px] border-[#e4d5d7] mb-6"></div>
        <div className="space-y-5">
          <div className="flex  justify-center md:justify-start ">
            <div className="flex space-x-5 w-1/3 space-y-3">
              <img src={currentWineData?.image !== "" ? currentWineData?.image : defaultImage} className="w-25 h-24 border border-[#8B24332B] rounded-lg" />
              {/* <img src={currentWineData?.image2 || ""} className="w-25 h-24 border border-[#8B24332B] rounded-lg" /> */}
              {/* <img src={currentWineData?.image3 || ""} className="w-25 h-24 border border-[#8B24332B] rounded-lg" /> */}
              {/* <img src={wine2} className="w-12 h-15 rounded-lg" /> */}
              {/* <img src={wine3} className="w-12 h-15 rounded-lg" /> */}
            </div>
          </div>
        </div>

        <h3 className="text-xl font-bold mt-8 mb-4 poppins-regular">Caratteristiche</h3>
        <div className="border-b-[1px] border-[#e4d5d7] mb-6"></div>
        <div className="space-y-5">
          <div className="flex md:flex-row flex-col gap-6">
            <div className="flex flex-col md:w-[50%] w-fll space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Nazione:
              </label>
              <input
                type="text"
                placeholder="Chardonnay"
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                value={currentWineData?.nation || ""}
                disabled
              />
            </div>
            <div className="flex flex-col md:w-[50%] w-fll space-y-3">
              <label className="text-sm text-[#404040] font-semibold poppins-regular">
                Regione:
              </label>
              <input
                type="text"
                placeholder="Spumante"
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                value={currentWineData?.region || ""}
                disabled
              />
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-6">
            <div className="flex flex-col md:w-[50%] w-full space-y-3">
              <label className="text-sm text-[#404040] font-semibold poppins-regular">
                Vitigno:
              </label>
              <input
                type="text"
                placeholder="Chardonnay"
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                value={currentWineData?.grape_variety || ""}
                disabled
              />
            </div>
            <div className="flex flex-col md:w-[50%] w-fll space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Tipologia:
              </label>
              <input
                type="text"
                placeholder="Spumante"
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                value={currentWineData?.type || ""}
                disabled
              />
            </div>
          </div>
          <div className="flex md:flex-row flex-col  gap-6 w-full">
            <div className="flex flex-col md:w-[50%] w-full space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Stato:
              </label>
              <input
                type="text"
                placeholder="-"
                className="bg-[#E5E5E5] px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-gray-400 focus:bg-[#e2dbdb] poppins-regular"
                // value={currentWineData?.status ? (currentWineData?.status === "Active" ? "Attivo" : "Inattivo") : "N/A"}
                disabled
              />
            </div>
            <div className="flex flex-col md:w-[50%] w-full space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Quantità:
              </label>
              <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                <div className="0  rounded-[28px]">
                  <button
                    className=" border border-gray-30 inline-flex justify-between items-center w-full relative z-10 poppins-regular px-4 py-[12px]  text-xs text-[#8B8B8B] rounded-[28px] bg-transparent   focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]   "
                    onClick={() => toggleDropdownBoxQuantity(currentWineData?.id)}>
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      {quantities || "0"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${openDropdownQuantity ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${openDropdownQuantity
                      ? "max-h-60 opacity-100 relative overflow-y-auto"
                      : "max-h-0 opacity-0 overflow-hidden"
                      } bg-[#FFFFFF] absolute top-0 p-2 border border-gray-30 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out z-[999]`}
                  >
                    {currentWineData?.meta?.map((item) => (
                      <label
                        key={item.id}
                        className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn"
                        onClick={() =>
                          handleQuantitySelect(
                            currentWineData?.id,
                            item?.quantity
                          )
                        }
                      >
                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                          {item?.quantity}
                        </span>
                      </label>
                    ))}
                    {currentWineData?.meta?.length === 0 && (
                      <label>
                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                          0
                        </span>
                      </label>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-start mt-8">
          <button
            className="md:w-[120px] w-full flex items-center justify-center space-x-2 p-1 px-3 border-[1.5px] border-[#8B2433] text-[#8B2433] rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={handleCancel}
          >
            <IoIosArrowBack size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Indietro</span>
          </button>
        </div>
      </div>
    </section>
  );
};

WineView.propTypes = {
  currentWineData: PropTypes.shape({
    name: PropTypes.string,
    short_description: PropTypes.string,
    long_description: PropTypes.string,
    served_price: PropTypes.string,
    b2b_price: PropTypes.string,
    image: PropTypes.string,
    image2: PropTypes.string,
    image3: PropTypes.string,
    nation: PropTypes.string,
    region: PropTypes.string,
    grape_variety: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
    quantity: PropTypes.number,
  }),
  handleCancel: PropTypes.func.isRequired,
};

export default WineView;